import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail } from "lucide-react";
import Logo from "./Logo";
import { SITE } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200" data-testid="site-footer">
      <div className="container-x grid gap-12 md:grid-cols-2 lg:grid-cols-5 py-16">
        {/* Logo + tagline */}
        <div className="lg:col-span-1">
          <Logo className="h-20 w-auto" />
          <p className="font-display tracking-[0.22em] text-sm text-green-brand mt-4">
            LEAD. SERVE. REPRESENT.
          </p>
        </div>

        <Column title="About">
          <FLink to="/about#mvv-title">Our Mission</FLink>
          <FLink to="/about#team-title">Leadership &amp; Advisory Council</FLink>
        </Column>

        <Column title="Get Involved">
          <FLink to="/get-involved#join-form">Volunteer</FLink>
          <FLink to="/get-involved#join-form">Host an Event</FLink>
          <li>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfS1SlR6ouD7H6YhSv-5zdpdPZPZMktnBq6XrpTnRCywybKpQ/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-green-brand transition-colors"
              data-testid="footer-apply-endorsement"
            >
              Apply for Endorsement
            </a>
          </li>
          <FLink to="/get-involved#join-form">Join Our Network</FLink>
        </Column>

        <Column title="Resources">
          <FLink to="/endorsements">Endorsements</FLink>
          <FLink to="/events">Events</FLink>
          <FLink to="/news">News &amp; Updates</FLink>
          <FLink to="/store">Store</FLink>
        </Column>

        <div>
          <h3 className="font-display tracking-[0.22em] text-sm text-navy uppercase mb-4">
            Contact
          </h3>
          <a
            href={`mailto:${SITE.email}`}
            className="text-sm text-navy-deep/85 hover:text-green-brand transition-colors break-all"
            data-testid="footer-email"
          >
            {SITE.email}
          </a>
          <div className="flex items-center gap-3 mt-6">
            <SocialLink href={SITE.facebook} icon={Facebook} label="Facebook" />
            <SocialLink href={SITE.instagram} icon={Instagram} label="Instagram" />
            <SocialLink href={`mailto:${SITE.email}`} icon={Mail} label="Email" />
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="border-t border-gray-200 bg-gray-soft/60">
        <div className="container-x py-6 grid gap-4 md:flex md:items-center md:justify-between">
          <p className="text-xs text-navy-deep/65 max-w-3xl">
            {SITE.pacDisclaimer}
          </p>
          <div className="flex items-center gap-3">
            <a
              href={SITE.donateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              data-testid="donate-button-footer"
            >
              Donate
            </a>
            <Link to="/get-involved" className="btn btn-outline" data-testid="join-button-footer">
              Join Network
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function Column({ title, children }) {
  return (
    <div>
      <h3 className="font-display tracking-[0.22em] text-sm text-navy uppercase mb-4">
        {title}
      </h3>
      <ul className="flex flex-col gap-3 text-sm text-navy-deep/85">{children}</ul>
    </div>
  );
}

function FLink({ to, children }) {
  return (
    <li>
      <Link to={to} className="hover:text-green-brand transition-colors">
        {children}
      </Link>
    </li>
  );
}

function SocialLink({ href, icon: Icon, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-green-brand text-white hover:bg-navy hover:scale-110 transition-all duration-200"
      data-testid={`footer-social-${label.toLowerCase()}`}
    >
      <Icon size={16} />
    </a>
  );
}
